import React, { useEffect } from 'react';
import { RxCross2 } from 'react-icons/rx';

interface RejectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
    patientName: string;
}

const RejectionModal: React.FC<RejectionModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading = false,
    patientName,
}) => {
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (keyCode === 27) onClose(); // ESC key
        };
        if (isOpen) {
            document.addEventListener('keydown', keyHandler);
        }
        return () => document.removeEventListener('keydown', keyHandler);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className='fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5'
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
            >
                <button
                    className='absolute right-4 top-4 text-gray-600 hover:text-gray-900'
                    onClick={onClose}
                    disabled={isLoading}
                >
                    <RxCross2 />
                </button>
                <div className='p-8'>
                    <div className='mb-6'>
                        <h2 className='mb-6 text-[22px] font-bold text-black'>
                            Reject Campaign Request
                        </h2>
                        
                        <p className='mb-4 text-gray-700'>
                            Are you sure you want to reject the campaign request for{' '}
                            <span className='font-semibold'>{patientName}</span>?
                        </p>
                        
                        <p className='mb-6 text-gray-700'>
                            This action will set the status to{' '}
                            <span className='inline-flex rounded-full bg-gray-300 px-2 py-1 text-sm font-medium text-black'>
                                Rejected
                            </span>
                            {' '}and close any associated campaign.
                        </p>
                    </div>

                    <div className='flex justify-start space-x-4'>
                        <button
                            onClick={onClose}
                            disabled={isLoading}
                            className='rounded-full border-[2px] border-gray-300 bg-white px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-black transition-colors duration-500 hover:border-black hover:bg-black hover:text-white disabled:cursor-not-allowed disabled:opacity-50'
                        >
                            CANCEL
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isLoading}
                            className='rounded-full border-[2px] border-[#F02D3A] bg-[#F02D3A] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-white transition-colors duration-500 hover:border-[#c91e2a] hover:bg-[#c91e2a] disabled:cursor-not-allowed disabled:opacity-50'
                        >
                            {isLoading ? 'REJECTING...' : 'REJECT'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RejectionModal;

